import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// --- App Check (P3c: AUTH-VULN-01/03/06 mitigation) ---
// Enables attestation tokens on all callable function requests,
// blocking automated abuse (brute-force login, password-reset flooding).
//
// IMPORTANT: You must also enable "Email Enumeration Protection" in
// Firebase Console > Authentication > Settings to mitigate AUTH-VULN-02.
//
if (typeof window !== 'undefined') {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6Ld8oqksAAAAAGwbt4X3VUBLSFLhv9cZhQgcs_f-'),
    isTokenAutoRefreshEnabled: true,
  });
}

const auth = getAuth(app);
const functions = getFunctions(app);
const db = getFirestore(app);

if (process.env.REACT_APP_USE_EMULATORS === 'true') {
    const authPort = parseInt(process.env.REACT_APP_EMULATOR_AUTH_PORT || '9099');
    const firestorePort = parseInt(process.env.REACT_APP_EMULATOR_FIRESTORE_PORT || '8080');
    const functionsPort = parseInt(process.env.REACT_APP_EMULATOR_FUNCTIONS_PORT || '5001');

    connectAuthEmulator(auth, `http://127.0.0.1:${authPort}`);
    connectFirestoreEmulator(db, '127.0.0.1', firestorePort);
    connectFunctionsEmulator(functions, '127.0.0.1', functionsPort);

    console.log(`🔧 Firebase emulators: Auth(:${authPort}) Firestore(:${firestorePort}) Functions(:${functionsPort})`);
}

export { auth, functions, db };